//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SalesForceTable from "@/pages/Sellers/components/SalesForceTable.vue";
import TeamsTable from "@/pages/Sellers/components/TeamsTable.vue";
import RoutesTable from "@/pages/Sellers/components/RoutesTable.vue";
import SalesForceTab from "@/pages/Sellers/components/SalesForceTab.vue";
import TeamsTab from "@/pages/Sellers/components/TeamsTab.vue";
import RoutesTab from "@/pages/Sellers/components/RoutesTab.vue";
import BackendServices from "@/services/backend-services.js";
import { Feedback } from "@/utils/notify-toaster.js";

export default {
  name: "Sellers",
  components: {
    SalesForceTable,
    TeamsTable,
    RoutesTable,
    SalesForceTab,
    TeamsTab,
    RoutesTab,
  },
  mounted: function () {
    this.askForSellersData({ pagination: { page: 1, rowsPerPage: 8 } });
    this.askForTeamsData({ pagination: { page: 1, rowsPerPage: 8 } });
    this.askForRoutesData({ pagination: { page: 1, rowsPerPage: 8 } });
  },
  data: () => ({
    tab: "sales-force",
    salesForceForm: false,
    teamsForm: false,
    routesForm: false,
    rightSidePane: false,
    search: null,
    recordsTotal: {
      sellers: null,
      teamData: null,
      routeData: null,
    },
    sellerData: [],
    teamsData: [],
    routeData: [],
    seller: {},
    team: {},
    route: {},
  }),
  methods: {
    deleteEvent: function (event) {
      if (event === 204) {
        this.changeTab({});
        if (this.tab === "sales-force") {
          this.askForSellersData({ pagination: { page: 1, rowsPerPage: 8 } });
        }
        if (this.tab === "teams") {
          this.askForTeamsData({ pagination: { page: 1, rowsPerPage: 8 } });
        }
        if (this.tab === "routes") {
          this.askForRoutesData({ pagination: { page: 1, rowsPerPage: 8 } });
        }
        Feedback.success("Elemento removido com sucesso.");
      } else {
        Feedback.error("Erro a remover elemento.");
      }
    },
    renderRightSide: function (event) {
      this.rightSidePane = true;
      if (this.tab === "sales-force") {
        this.seller = event;
      }
      if (this.tab === "teams") {
        this.team = event;
      }
      if (this.tab === "routes") {
        this.route = event;
      }
    },
    exportEmployees: function () {
      BackendServices.downloadEmployeeList(this.search).then((response) => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "Employees.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    exportTeams: function () {
      BackendServices.downloadTeamList(this.search).then((response) => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "Employees.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    askForSellersData(event) {
      BackendServices.getSalesforceEmployees(
        event.pagination,
        event.filter
      ).then((response) => {
        this.recordsTotal.sellers = response.headers["x-total-count"];
        this.sellerData = response.data;
      });
    },
    askForTeamsData(event) {
      BackendServices.getSalesforceTeams(event.pagination, event.filter).then(
        (response) => {
          this.recordsTotal.teamData = response.headers["x-total-count"];
          this.teamsData = response.data;
        }
      );
    },
    askForRoutesData(event) {
      BackendServices.getSalesforceRoutes(event.pagination, event.filter).then(
        (response) => {
          this.recordsTotal.routeData = response.headers["x-total-count"];
          this.routeData = response.data;
        }
      );
    },
    changeTab: async function (event) {
      this.rightSidePane = false;
      this.seller = {};
      this.team = {};
      this.route = {};
      await this.$nextTick();
      if (event === "sales-force") {
        this.askForSellersData({ pagination: { page: 1, rowsPerPage: 8 } });
      }
      if (event === "teams") {
        this.askForTeamsData({ pagination: { page: 1, rowsPerPage: 8 } });
      }
      if (this.tab === "routes") {
        this.askForRoutesData({ pagination: { page: 1, rowsPerPage: 8 } });
      }
    },
    createNew: function () {
      this.salesForceForm = false;
      this.teamsForm = false;
      this.routesForm = false;
      this.seller = {};
      this.team = {
        members: [],
        managers: [],
        member_ids: [],
        manager_ids: [],
      };
      this.route = {
        product_hierarchy_ids: [],
        employee_ids: [],
        store_ids: [],
      };
      this.rightSidePane = true;
    },
    saveEntity: function () {
      let hasSeller = this.tab === "sales-force";
      let hasTeam = this.tab === "teams";
      let hasRoute = this.tab === "routes";
      let operation = null;
      if (hasSeller) {
        let sellerId = this.seller.id;
        operation = sellerId
          ? BackendServices.updateExistingSalesforceEmployee(this.seller)
          : BackendServices.createNewSalesforceEmployee(this.seller);
      }
      if (hasTeam) {
        let teamId = this.team.id;
        operation = teamId
          ? BackendServices.updateExistingSalesforceTeam(this.team)
          : BackendServices.createNewSalesforceTeam(this.team);
      }
      if (hasRoute) {
        let routeId = this.route.id;
        operation = routeId
          ? BackendServices.updateExistingSalesforceRoute(this.route)
          : BackendServices.createNewSalesforceRoute(this.route);
      }
      if (operation) {
        operation.then(() => {
          //TODO Add reactivity to the data && show a toastr message
          window.location.reload();
        });
      }
    },
  },
};
